export default function (props: any) {
    return (
        <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM8.2748 14.0424L13.365 10.6938C13.6653 10.4962 13.6653 10.0559 13.365 9.85833L8.2748 6.5097C7.94233 6.29098 7.5 6.52946 7.5 6.92742V10.276L7.5 13.6247C7.5 14.0226 7.94233 14.2611 8.2748 14.0424Z"
                fill="black"
            />
        </svg>
    );
}
